import $ from 'jquery';


const Modal = function () {
  // Modal Contents Data
  let modalData;
  if ($('body').hasClass('recruit-team')) {
    modalData = {
      1: {
        title: '企画職',
        note: '主な業務：<strong>ゲームの開発や運営の企画、プロデューサーや各セクションとの調整、データ分析など</strong>',
        contents: [
          {
            position: 'プランナー',
            description: 'ゲームの仕様書作成、バランス設計、レベルデザイン、世界観構築、進行管理、社内外との折衝・調整対応などを担当'
          },
          {
            position: 'データ分析',
            description: 'SQLや統計分析ツールを用いたゲーム運営課題に対するログデータ分析、レポーティング及びサービス改善提案などを担当'
          },
          {
            position: 'プロジェクトマネジメント',
            description: 'プロジェクトのタスク管理及び進捗管理、各セクションとの情報共有、スケジュール調整、社内外との折衝・調整対応などを担当'
          }
        ]
      },
      2: {
        title: 'クリエイティブ職',
        note: '主な業務：<strong>ゲームに用いられる各種コンテンツ制作など</strong>',
        contents: [
          {
            position: 'シナリオ',
            description: 'ゲーム内シナリオ・キャラクターメイキング及びフレーバーテキスト・台本等の作成・ディレクション、外注シナリオライターの進行管理、クオリティ管理及びコスト管理などを担当'
          },
          {
            position: 'イラスト',
            description: 'キャラクター、アバターなど人物系のイラストレーション制作、背景イラストレーション制作などを担当'
          },
          {
            position: '3DCG',
            description: 'Unity、3Dツールを使用した3Dキャラモデル作成や、エフェクト制作・組込・オーサリング等エフェクトの品質管理、必殺技アクションやモーション制作などを担当'
          }
          ,
          {
            position: 'UI/UX',
            description: 'ゲーム内のUI/UX設計及びアイコン・バナー・画面デザインのUIグラフィック制作などを担当'
          }
          ,
          {
            position: 'サウンド',
            description: 'ゲーム内SE、ボイス制作編集、各種サウンド管理、社外との折衝、発注・納品物管理、ディレクションなどを担当'
          }
        ]
        ,
        aside: {
          img: '../assets/img/team/g-row02.png',
          alt: 'G-ROW ARTISTRY',
          text: '※G-ROW ARTISTRY<br>Studio FgGのコンテンツ制作を担う5セクション<br>（シナリオ・イラスト・3DCG・UI/UX・サウンド）の総称'
        }
      },
      3: {
        title: 'グローバルビジネス職',
        note: '主な業務：<strong>ゲームの海外配信に必要な企画やローカライズ（カルチャライズ）など</strong>',
        contents: [
          {
            position: '海外プランナー',
            description: 'ゲームの仕様書作成、バランス設計、レベルデザイン、世界観構築、進行管理、社内外（主に海外拠点）との折衝・調整対応などを担当'
          },
          {
            position: 'ローカライズ',
            description: '日本語から各言語への翻訳、外部翻訳者により翻訳されたテキストの監修、実装されたテキストのチェック・修正対応などを担当'
          }
        ]
      },
      5: {
        title: '技術職',
        note: '主な業務：<strong>ゲーム開発・運用、品質管理、ユーザーサポート、改善提案など</strong>',
        contents: [
          {
            position: 'エンジニア（クライアント/サーバー）',
            description: 'ゲーム開発(設計、実装、テスト)、ゲーム運用(本番更新・不具合修正・監視）、開発環境・ツール作成、プログラム改善(高速化、最適化)などを担当'
          },
          {
            position: 'エンジニア（技術基盤）',
            description: '各種システム設計、実装、インフラ構築、デプロイ、モニタリング、サポートなどを担当'
          },
          {
            position: 'QA',
            description: 'ゲームレビュー、レポートのフィードバック、品質基準策定、プロジェクトのサポートなどを担当'
          }
          ,
          {
            position: 'CS',
            description: 'ユーザーからの問い合わせ・意見等への対応、及びそれらを踏まえたゲーム改善の社内提案などを担当'
          }
        ]
      },
      6: {
        title: '広告・宣伝職',
        note: '主な業務：<strong>各種プロモーション企画の立案・遂行など</strong>',
        contents: [
          {
            position: 'PR・マーケティング',
            description: 'プロモーションの企画・運営、SNS・Web等でのユーザーコミュニケーション、社内関係部門・広告代理店・制作会社との折衝・調整などを担当'
          }
        ]
      },
    }
  } else if ($('body').hasClass('recruit-workstyle')) {
    modalData = {
      1: {
        title: 'プランナー',
        text: '極力余計なものは置かないように、きれいにすることを心がけています。<br>チャットを読む時間が多いので縦画面は常にSlackです。',
        img: {
          path: '../assets/img/workstyle/figure01_modal.png',
          alt: 'プランナー'
        }
      },
      2: {
        title: 'PR',
        text: '担当タイトルのプロモーション全般を担当してます！<br>なるべくデスクはすっきりさせたいと思いつつも、気づくと資料などであふれています...<br>時間を効率よく使えるよう、目につく位置にスケジュールやタスクを書き出して、優先順位を決めて仕事を行っています。',
        img: {
          path: '../assets/img/workstyle/figure02_modal.png',
          alt: 'PR'
        }
      },
      3: {
        title: 'イラストレーター①',
        text: '主にPhotoshopとWacomのペンタブレットで作業しています。<br>仕事の忙しさに比例して机が参考資料等で散らかりがちになるので、定期的に整理整頓して切り替えられるように心がけています。',
        img: {
          path: '../assets/img/workstyle/figure03_modal.png',
          alt: 'イラストレーター①'
        }
      },
      4: {
        title: 'イラストレーター②',
        text: '主にキャラクターイラストを描きつつ必要に応じて背景やエネミーなど、世界観に関わる部分を幅広く担当しています。<br>作業環境は液晶タブレットを使い、PhotoshopやClip studioで作業しています。<br>机やその周りの本棚には参考資料として画集やフィギュア等があり、少し手を伸ばせば届く範囲なので気に入っています！',
        img: {
          path: '../assets/img/workstyle/figure04_modal.png',
          alt: 'イラストレーター②'
        }
      },
      5: {
        title: '3DCGデザイナー',
        text: '『ファントム オブ キル』のエフェクト制作や品質管理をしています。<br>使用ツールは主にUnity shuriken、Maya、Photoshop、After Effectsなど使っています。<br>画面はアロンダイトというキャラクターの必殺技の最終調整をしているところです。',
        img: {
          path: '../assets/img/workstyle/figure05_modal.png',
          alt: '3DCGデザイナー'
        }
      },
      6: {
        title: 'クライアントエンジニア①',
        text: '首痛、肩凝りという最大の問題を解決するため、分割キーボードとエルゴノミクスアームを使っています。<br>使い始めてからこれらとは、無縁になりました。',
        img: {
          path: '../assets/img/workstyle/figure06_modal.png',
          alt: 'クライアントエンジニア①'
        }
      },
      7: {
        title: 'クライアントエンジニア②',
        text: '右のモニターの土台に乗っているのは飼っている猫のひげです。<br>猫のひげは金運アップのお守りにもなるのでプロジェクトには必須のアイテムです。',
        img: {
          path: '../assets/img/workstyle/figure07_modal.png',
          alt: 'クライアントエンジニア②'
        }
      },
      8: {
        title: 'サーバーエンジニア',
        text: 'アプリの開発の管理とインフラ周りの管理をしており、デスクにはPC以外必要ないので基本的に片付いています。<br>『ファントム オブ キル』のTwitterで毎月公開されているカレンダーを印刷して使っているのと、ノベルティ―で作ったお菓子の箱は捨てずに飾っていますが、空き箱です。',
        img: {
          path: '../assets/img/workstyle/figure08_modal.png',
          alt: 'サーバーエンジニア'
        }
      },
      9: {
        title: 'ローカライズ',
        text: 'ドイツ語チームのリーダーとして、主に幻影戦争の海外版のドイツ語ローカライズ（翻訳）を担当しています。作業の大半は、MemoQという少し癖の強いソフトを使っています（笑）PCの小さい画面でMemoQの作業をしながら、左のモニターに写っているトラッカー（タスク一覧）でタスクのIDや締め切りを把握して、右のモニターで調べ物をしています。クリスマスシーズンが大好きなので、年中クリスマスの飾り付けをして癒されています！',
        img: {
          path: '../assets/img/workstyle/figure09_modal.png',
          alt: 'ローカライズ'
        }
      },

    }
  }

  const $trigger = $('.js-modal__trigger');
  const overlay = document.querySelector('.js-modal__overlay');
  const $close = $('.js-modal__close');

  class Modal {
    constructor(trigger) {
      this._trigger = trigger;
      this._$el = $('.js-modal');
      this._overlay = overlay;
      this._num;
      this._$close = $close;
      this._$title = $('#js-modal__title');
      this._$note = $('#js-modal__note');
      this._$detail = $('#js-modal__detail');
      this._$aside = $('#js-modal__aside');
      this._$text = $('#js-modal__text');
      this._$figure = $('#js-modal__figure');
      this._$scroller = $('#js-modal__scroller');
      this._pager = document.querySelectorAll('.js-modal__pager');
      this._pagerLeft = document.querySelector('#js-modal__left');
      this._pagerRight = document.querySelector('#js-modal__right');
      this._data = modalData[this._num];
      this.init();
    }
    init() {
      const self = this;
      this._trigger.on('click', function () {
        self._num = $(this).attr('data-modal');
        self.open(self);
      });
      this._overlay.addEventListener('click', () => { this.close(self) });
      this._$close.on('click', () => { this.close(self) });
      if (this._pager.length > 0) {
        this._pagerRight.addEventListener('click', () => { this.nextModal(), this.scrollJudge() });
        this._pagerLeft.addEventListener('click', () => { this.prevModal(), this.scrollJudge() });
      }
    }
    nextModal() {
      this._num = Number(this._num) === 9 ? 1 : Number(this._num) + 1;
      this.pager();
    }
    prevModal() {
      this._num = Number(this._num) === 1 ? 9 : Number(this._num) - 1;
      this.pager();
    }
    pager() {
      this._data = modalData[this._num];
      this.reset();
      this.setText();
    }
    scrollJudge() {
      // スクロールインジケーター
      let innerHi = $('.c-modal02__inner').height();
      let scrollerHi = document.querySelector('.c-modal02__scroller').scrollHeight;
      if (scrollerHi > innerHi) {
        this._$scroller.show();
      } else {
        this._$scroller.hide();
      }
    }
    setText() {
      // Title
      this._$title ? this._$title.html(this._data.title) : false;
      // Note
      this._$note ? this._$note.html(this._data.note) : false;
      // Detail
      if (this._data.contents) {
        this._data.contents.forEach(v => {
          this._$detail.append(`<dl class="detail"><dt>${v.position}</dt><dd>${v.description}</dd></dl>`)
        })
      }
      // Aside
      if (this._data.aside && this._data.aside.img && this._data.aside.text) {
        this._$aside.append(`<figure><img src="${this._data.aside.img}" alt="${this._data.aside.alt}"></figure><p>${this._data.aside.text}</p>`)
      }
      // Text
      this._$text ? this._$text.html(this._data.text) : false;
      // Figure
      if (this._data.img) {
        this._$figure.css('display', 'block');
        this._$figure.append(`<img src="${this._data.img.path}" alt="${this._data.img.alt}">`)
      } else {
        this._$figure.css('display', 'none');
      }
    }
    reset() {
      this._$title.html("");
      this._$note.html("");
      this._$detail.html("");
      this._$aside.html("");
      this._$text.html("");
      this._$figure.children('img').remove();
    }
    open(self) {
      self._data = modalData[self._num];
      self.bodyFixed();
      self.setText();
      self._$el.fadeIn();
      self.scrollJudge();
      $(window).on('resize', self.scrollJudge.bind(this));
    }
    close(self) {
      $('.c-modal02__scroller').scrollTop(0);
      self._$el.fadeOut().promise().done(function () {
        self.reset();
      });
      self.bodyFixed();
    }
    bodyFixed() {
      $('body').toggleClass('is-fixed');
      this.currentPositionCalculation();
    }
    currentPositionCalculation() {

      // 背景固定
      const position = window.scrollY || window.pageYOffset;
      if ($('body').hasClass('is-fixed')) {
        // bodyを浮かせる
        $('body').css({
          'position': 'fixed',
          'top': `-${position}px`,
        });
      } else {
        // 解除
        const top = document.body.style.top;
        $('body').css({
          'top': '',
          'position': ''
        });
        window.scrollTo(0, parseInt(top) * -1);
      }
    }
  }
  if (document.querySelector('.js-modal')) {
    new Modal($trigger);
  }
}

export default Modal;



// WEBPACK FOOTER //
// ./src/recruit/js/modal.js